module.exports = __webpack_public_path__ + "img/2.175109bb.svg";